// ACQ-00 — el código de handoff que trae una persona desde una herramienta pública.
//
// Viaja en el FRAGMENTO de la URL (`#handoff=…`), nunca en la query: así no llega al
// servidor en el request ni viaja en `Referer`. Se guarda en `sessionStorage` solo
// para sobrevivir al alta y la confirmación de correo; no es identidad ni prueba de
// propiedad — quien decide es el canje autenticado del Worker.

const STORAGE_KEY = 'destakia:acq-handoff';
const FRAGMENT_KEY = 'handoff';

/** Toma el código del fragmento (si existe), lo guarda y limpia la URL. */
export function captureHandoffCode(): void {
  if (typeof window === 'undefined') return;
  const hash = window.location.hash.replace(/^#/, '');
  if (!hash) return;
  const params = new URLSearchParams(hash);
  const code = params.get(FRAGMENT_KEY)?.trim();
  if (!code) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, code.slice(0, 200));
  } catch {
    // Navegación privada o almacenamiento bloqueado: el alta sigue funcionando,
    // solo se pierde el atajo de importación.
  }
  params.delete(FRAGMENT_KEY);
  const rest = params.toString();
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${rest ? `#${rest}` : ''}`);
}

/** Devuelve el código guardado y lo consume: un handoff es de un solo uso. */
export function takeHandoffCode(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const code = sessionStorage.getItem(STORAGE_KEY);
    if (code) sessionStorage.removeItem(STORAGE_KEY);
    return code;
  } catch {
    return null;
  }
}
